module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-detail"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("User Management")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("User Detail")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Informasi Detail User")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-body"
  }, [_c('div', {
    staticStyle: {
      "background": "white",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('img', {
    staticClass: "media-object",
    attrs: {
      "src": _vm.userData.picture,
      "alt": "profile_picture"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "150px",
      "border": "1px solid green",
      "padding": "15px",
      "margin": "10px",
      "text-align": "center",
      "border-radius": "5px"
    }
  }, [_vm._v("\n            Jumlah Tiket\n            "), _c('h3', {
    staticStyle: {
      "line-height": "0"
    }
  }, [_vm._v(_vm._s(_vm.users_ticket))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "150px",
      "border": "1px solid green",
      "padding": "15px",
      "margin": "10px",
      "text-align": "center",
      "border-radius": "5px"
    }
  }, [_vm._v("\n            Jumlah Kuota Konsul\n            "), _c('h3', {
    staticStyle: {
      "line-height": "0"
    }
  }, [_vm._v(_vm._s(_vm.users_consul_session))])])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.name))])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.student_number))])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.email) + "\n                      "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "font-size": "11px",
      "padding": "5px 7px 5px 7px",
      "margin-left": "15px"
    },
    on: {
      "click": function($event) {
        return _vm.showEditEmail()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.phone_number))])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.province))])]), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.city))])]), _vm._v(" "), _c('tr', [_vm._m(7), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.school_type))])]), _vm._v(" "), _c('tr', [_vm._m(8), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.school ? _vm.userData.school : '') + "\n                      "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "font-size": "11px",
      "padding": "5px 7px 5px 7px",
      "margin-left": "15px"
    },
    on: {
      "click": function($event) {
        return _vm.showEditForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])]), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grade),
      expression: "grade"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.grade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _vm._l((12), function(n) {
    return _c('option', {
      key: n,
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  })], 2)])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(11), _vm._v(" "), _vm._l((_vm.scopeModel), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_vm._v("\n              " + _vm._s(item.display_name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "display": "flex",
        "flex-flow": "row"
      }
    }, [_c('date-picker', {
      attrs: {
        "value-type": "timestamp",
        "valueType": "format"
      },
      on: {
        "change": function($event) {
          return _vm.updateTanggalScope(item, index)
        }
      },
      model: {
        value: (_vm.scopeModel[index].expired_at),
        callback: function($$v) {
          _vm.$set(_vm.scopeModel[index], "expired_at", $$v)
        },
        expression: "scopeModel[index].expired_at"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xl",
      staticStyle: {
        "margin-left": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.deleteScope(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1)])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.memberships), function(membership, key) {
    return _c('div', {
      key: key,
      staticClass: "tryout-section",
      staticStyle: {
        "margin-bottom": "50px"
      }
    }, [_c('h4', [_vm._v(_vm._s(membership.name))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(" + _vm._s(_vm.displayTimestamp(membership.opened_at)) + " - " + _vm._s(_vm.displayTimestamp(membership.closed_at)) + ")")])]), _vm._v(" "), _c('table', {
      staticClass: "table"
    }, [_vm._m(13, true), _vm._v(" "), _vm._l((membership.tryouts), function(tryout, key) {
      return _c('tr', {
        key: key
      }, [_c('td', [_vm._v(_vm._s(tryout.name))]), _vm._v(" "), _c('td', [(tryout.state === 'JOINED') ? _c('div', {
        staticClass: "tryout-state"
      }, [_c('button', {
        staticClass: "btn btn-default btn-xs"
      }, [_vm._v("BERGABUNG")])]) : _vm._e(), _vm._v(" "), (tryout.state === 'STARTED') ? _c('div', {
        staticClass: "tryout-state text-center"
      }, [_vm._v(" \n                    "), _c('button', {
        staticClass: "btn btn-warning btn-xs mb-1"
      }, [_vm._v("MENGERJAKAN")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.displayTimestamp(tryout.started_at)) + ")")])]) : _vm._e(), _vm._v(" "), (tryout.state === 'FINISHED') ? _c('div', {
        staticClass: "tryout-state text-center"
      }, [_vm._v(" \n                    "), _c('button', {
        staticClass: "btn btn-warning btn-xs mb-1"
      }, [_vm._v("MENGUMPULKAN")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.displayTimestamp(tryout.completed_at)) + ")")])]) : _vm._e(), _vm._v(" "), (tryout.state === 'GRADED') ? _c('div', {
        staticClass: "tryout-state"
      }, [_c('button', {
        staticClass: "btn btn-success btn-xs"
      }, [_vm._v("DINILAI")])]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tryout.completion_time ? Math.ceil(tryout.completion_time / 60) : '-'))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm.getItemCount(tryout)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tryout.correct))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tryout.wrong))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tryout.empty))]), _vm._v(" "), _c('td', {
        staticClass: "text-center d-flex"
      }, [_c('button', {
        staticClass: "btn btn-warning btn-xs mr-1",
        attrs: {
          "disabled": tryout.state === 'JOINED'
        },
        on: {
          "click": function($event) {
            return _vm.resetState(tryout.bundle_code, _vm.$store.state.usman.email)
          }
        }
      }, [_vm._v("RESET")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-success btn-xs",
        attrs: {
          "disabled": tryout.state === 'JOINED'
        },
        on: {
          "click": function($event) {
            return _vm.gradingState(tryout.bundle_code, _vm.$store.state.usman.email)
          }
        }
      }, [_vm._v("GRADING")])])])
    })], 2)])
  }), 0)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-sm",
    attrs: {
      "id": "modalEditEmail",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "FilterModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    staticStyle: {
      "max-width": "400px !important"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('form', {
    attrs: {
      "action": "submit"
    }
  }, [_c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Email Saat Ini")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.detailUser.email))])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Masukkan email baru")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukkan email baru"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "focus": function($event) {
        _vm.newEmail = ''
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.listEmailSigned != null && _vm.listEmailSigned.length > 0) ? _c('div', _vm._l((_vm.listEmailSigned), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "padding-bottom": "7px",
        "padding-top": "7px",
        "border-bottom": "1px solid"
      }
    }, [_c('p', [_vm._v("Nama: " + _vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v("No Handphone: " + _vm._s(item.phone_number))]), _vm._v(" "), _c('p', [_vm._v("Tanggal Lahir: " + _vm._s(item.birth_date))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.listEmailSigned && _vm.listEmailSigned.length === 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("Email baru belum terdaftar dalam sistem")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkEmail()
      }
    }
  }, [_vm._v("\n              Cek Email Baru\n            ")]), _vm._v(" "), (_vm.listEmailSigned && _vm.listEmailSigned.length === 0) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updateEmail()
      }
    }
  }, [_vm._v("\n              Update Email\n            ")]) : _vm._e(), _vm._v(" "), (_vm.listEmailSigned && _vm.listEmailSigned.length === 1) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updateEmail()
      }
    }
  }, [_vm._v("\n              Swap Email\n            ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-sm",
    attrs: {
      "id": "modalEditSekolah",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "FilterModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    staticStyle: {
      "max-width": "400px !important"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('form', {
    attrs: {
      "action": "submit"
    }
  }, [_c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Jenis Sekolah")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formUpdateSekolah.jenisSekolah),
      expression: "formUpdateSekolah.jenisSekolah"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formUpdateSekolah, "jenisSekolah", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FORMAL"
    }
  }, [_vm._v("Formal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "INFORMAL"
    }
  }, [_vm._v("Informal")])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Provinsi")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formUpdateSekolah.provinsi),
      expression: "formUpdateSekolah.provinsi"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formUpdateSekolah, "provinsi", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.provinceList), function(province, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": province.value
      }
    }, [_vm._v(_vm._s(province.text))])
  }), 0)]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Kota/Kabupaten")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formUpdateSekolah.kota),
      expression: "formUpdateSekolah.kota"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formUpdateSekolah, "kota", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.cityList), function(city, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": city.value
      }
    }, [_vm._v(_vm._s(city.text))])
  }), 0)]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Nama Sekolah")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formUpdateSekolah.namaSekolah),
      expression: "formUpdateSekolah.namaSekolah"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": 'nama sekolah'
    },
    domProps: {
      "value": (_vm.formUpdateSekolah.namaSekolah)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.commitSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formUpdateSekolah, "namaSekolah", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px 15px 5px 15px",
      "font-size": "11px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.commitSearch()
      }
    }
  }, [_vm._v("Cari")])]), _vm._v(" "), (_vm.formUpdateSekolah.namaSekolah !== '' && _vm.showSuggestion) ? _c('ul', {
    staticClass: "list-group",
    staticStyle: {
      "max-height": "250px",
      "overflow": "auto"
    }
  }, [_vm._l((_vm.querySchool), function(suggestion, index) {
    return _c('li', {
      key: index,
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          return _vm.selectingSchool(suggestion)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(suggestion.text))])])
  }), _vm._v(" "), (_vm.formUpdateSekolah.namaSekolah !== '' && _vm.showSuggestion && _vm.querySchool.length === 0) ? _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("\n                    Data tidak ditemukan, perhatikan huruf besar kecil dan spasi!\n                  ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updateDataSekolah()
      }
    }
  }, [_vm._v("Update Data Siswa")])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("User Info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Nama")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("No. Siswa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("No. Telpon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Provinsi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Kota/Kabupaten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Jenis Sekolah")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Sekolah")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Kelas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Scope")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Nama Fitur")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v("Tanggal Expired")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Riwayat Pengerjaan Tryout (Beragenda)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Pengerjaan (Menit)")]), _vm._v(" "), _c('th', [_vm._v("Jml. Soal")]), _vm._v(" "), _c('th', [_vm._v("Benar")]), _vm._v(" "), _c('th', [_vm._v("Salah")]), _vm._v(" "), _c('th', [_vm._v("Kosong")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h4', {
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Ubah Email User")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "right": "15px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h4', {
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Ubah Data Sekolah User")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "right": "15px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40a32eee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/usman/UserManagementDetail.vue
// module id = 1329
// module chunks = 0